import React from 'react';
import { createRoot } from 'react-dom/client';
import providerHOC from 'app/utils/providerHOC/providerHOC';
import SearchApp from './searchApp';
import store from './searchStore';

const SearchRoot = providerHOC(store)(SearchApp);
createRoot(document.getElementById('search')).render(<SearchRoot />);
